// Function to safely get an item from localStorage
export function getSafeLocalStorageItem() {
  try {
    if (typeof localStorage !== 'undefined') {
      return true;
    }
  } catch (e) {
    console.warn('localStorage is not available or accessible:', e);
    return false;
  }
  return false;
}